(() => {
    'use strict';

    angular
        .module('uwAgenda.email')
        .controller(
            'RegenerateKeyWarningModalController',
            ['$uibModalInstance', RegenerateKeyWarningModalControllerFn]);

    function RegenerateKeyWarningModalControllerFn($uibModalInstance) {
        const vm = this;

        vm.confirm = function () {
            $uibModalInstance.close();
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();